var _rect, _text, _text2, _rect2, _text3, _rect3, _text4, _rect4, _text5, _rect5, _text6, _rect6, _text7, _line, _circle, _line2, _line3, _rect7, _text8, _circle2, _text9, _text10, _rect8, _text11, _rect9, _text12, _rect10, _text13, _rect11, _text14, _line4, _polygon, _rect12, _text15, _rect13, _text16, _rect14, _text17, _rect15, _text18, _rect16, _text19, _text20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg06SandboxGuardrails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 440",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 440,
    fill: "#f8fafc"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 40,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 700
  }, "Harness Guardrails")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 64,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13
  }, "What the agent can touch vs what stays protected")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 120,
    width: 170,
    height: 220,
    rx: 14,
    fill: "#fee2e2",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 155,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Host Machine")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 175,
    width: 130,
    height: 32,
    rx: 8,
    fill: "#fff",
    stroke: "#0f172a",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 196,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "SSH keys")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 218,
    width: 130,
    height: 32,
    rx: 8,
    fill: "#fff",
    stroke: "#0f172a",
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 239,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "Secrets / .env")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 261,
    width: 130,
    height: 32,
    rx: 8,
    fill: "#fff",
    stroke: "#0f172a",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 282,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "System files")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 304,
    width: 130,
    height: 22,
    rx: 6,
    fill: "#dc2626"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 320,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 700
  }, "BLOCKED")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 230,
    x2: 268,
    y2: 230,
    stroke: "#dc2626",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 230,
    r: 14,
    fill: "#fff",
    stroke: "#dc2626",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 237,
    y1: 223,
    x2: 251,
    y2: 237,
    stroke: "#dc2626",
    strokeWidth: 2.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 251,
    y1: 223,
    x2: 237,
    y2: 237,
    stroke: "#dc2626",
    strokeWidth: 2.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 100,
    width: 400,
    height: 260,
    rx: 18,
    fill: "#ffffff",
    stroke: "#0f172a",
    strokeWidth: 2.5,
    strokeDasharray: "9 6"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 132,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "Sandbox / Isolated Container")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 220,
    r: 46,
    fill: "#fecaca",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 215,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Agent")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 235,
    textAnchor: "middle",
    fill: "#475569",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "Loop")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 160,
    width: 100,
    height: 40,
    rx: 10,
    fill: "#bbf7d0",
    stroke: "#0f172a",
    strokeWidth: 2
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 185,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Allowlist")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 160,
    width: 100,
    height: 40,
    rx: 10,
    fill: "#fef3c7",
    stroke: "#0f172a",
    strokeWidth: 2
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 185,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "HITL Gate")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 280,
    width: 100,
    height: 40,
    rx: 10,
    fill: "#bfdbfe",
    stroke: "#0f172a",
    strokeWidth: 2
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 305,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Disk Quota")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 280,
    width: 100,
    height: 40,
    rx: 10,
    fill: "#fce7f3",
    stroke: "#0f172a",
    strokeWidth: 2
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 305,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Mount Only")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 692,
    y1: 230,
    x2: 740,
    y2: 230,
    stroke: "#16a34a",
    strokeWidth: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "748,230 736,223 736,237",
    fill: "#16a34a"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 120,
    width: 170,
    height: 220,
    rx: 14,
    fill: "#dcfce7",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 839,
    y: 155,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Work Folder")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 774,
    y: 175,
    width: 130,
    height: 32,
    rx: 8,
    fill: "#fff",
    stroke: "#0f172a",
    strokeWidth: 1.5
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 839,
    y: 196,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "Source code")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 774,
    y: 218,
    width: 130,
    height: 32,
    rx: 8,
    fill: "#fff",
    stroke: "#0f172a",
    strokeWidth: 1.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 839,
    y: 239,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "Temp files")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 774,
    y: 261,
    width: 130,
    height: 32,
    rx: 8,
    fill: "#fff",
    stroke: "#0f172a",
    strokeWidth: 1.5
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 839,
    y: 282,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "Outputs")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 774,
    y: 304,
    width: 130,
    height: 22,
    rx: 6,
    fill: "#16a34a"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 839,
    y: 320,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 700
  }, "ALLOWED")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 410,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "Mistakes stay inside the sandbox. The host stays safe.")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06SandboxGuardrails);
export default __webpack_public_path__ + "static/media/06-sandbox-guardrails.52882dfb4b76ff5492a4c8983518046c.svg";
export { ForwardRef as ReactComponent };